import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

/**
 * ACCESS MATRIX API CONFIGURATION
 * Uses pms-api REST endpoints for permissions management.
 */

export const accessMatrixConfig = {
  // GET: All permissions grouped (builds the matrix template)
  getAllPermissions: {
    key: "getAllPermissions",
    url: "/api/v1/permissions",
    method: "GET",
    options: {
      ...QUERY_PRESETS.IMMUTABLE,
      networkMode: "online",
    },
  },

  // GET: Permissions assigned to a specific role
  getAccessPermissionsForRole: {
    key: "getAccessPermissionsForRole",
    url: (params) => `/api/v1/roles/${params.roleId}/permissions`,
    method: "GET",
    options: {
      staleTime: STALE_TIME.MEDIUM,
      gcTime: GC_TIME.LONG,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      networkMode: "online",
    },
  },

  // POST: Assign permissions to a role
  assignPermissions: {
    key: "assignPermissions",
    url: (data) => `/api/v1/roles/${data.roleId}/permissions`,
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAccessPermissionsForRole",
        "getAllPermissions",
        "getAllRoles",
      ],
    },
  },

  // DELETE: Revoke permissions from a role
  revokePermissions: {
    key: "revokePermissions",
    url: (data) => `/api/v1/roles/${data.roleId}/permissions`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAccessPermissionsForRole",
        "getAllPermissions",
        "getAllRoles",
      ],
    },
  },

  // Legacy keys kept for backward compatibility (redirect to new endpoints)
  getAccessMatrixForPmsAdmin: {
    key: "getAccessMatrixForPmsAdmin",
    url: "/api/v1/permissions",
    method: "GET",
    options: {
      ...QUERY_PRESETS.IMMUTABLE,
      networkMode: "online",
    },
  },

  getAccessMatrixForHotelOwner: {
    key: "getAccessMatrixForHotelOwner",
    url: "/api/v1/permissions",
    method: "GET",
    options: {
      ...QUERY_PRESETS.IMMUTABLE,
      networkMode: "online",
    },
  },

  // Legacy: kept for any code that references it
  saveAccessMatrix: {
    key: "saveAccessMatrix",
    url: (data) => `/api/v1/roles/${data.roleId}/permissions`,
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAccessPermissionsForRole",
        "getAllPermissions",
        "getAllRoles",
      ],
    },
  },

  checkPageAccess: {
    key: "checkPageAccess",
    url: "/api/v1/permissions",
    method: "GET",
    options: {
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.MEDIUM,
      refetchOnWindowFocus: false,
      retry: false,
      networkMode: "online",
    },
  },
};
